// src/pages/safety/SafetyLayout.jsx
import React from "react";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import { projectMenus } from "../../components/layout/ProjectMenus";
import Forbidden from "../../components/common/ui/Forbidden";

export default function SafetyLayout({ hasPermission }) {
  // if (!hasPermission) return <Forbidden />;

  const { title, base, sections } = projectMenus.safety;

  return (
    <SidebarLayout
      title={title}
      base={base}
      sections={sections}
    />
  );
}
